import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ResearchMcpApi } from './apis/research-mcp-api';
import { ResearchMcpApiImpl } from './apis/impls/research-mcp-api';
import { ResearchMcpService } from './services/research-mcp-service';
import { ResearchMcpServiceImpl } from './services/impls/research-mcp-service';

export const researchMcpContainer = new ContainerModule(bind => {
    bind(ResearchMcpApi).to(ResearchMcpApiImpl);
    bind(ResearchMcpService).to(ResearchMcpServiceImpl);
});
